@if (searchResult?.length > 0) {
  <div class="result-container">
    <div class="result-main">
      @for (item of searchResult | slice: 0 : resultLimit; track item) {
        <a
          class="search-option"
          [routerLink]="[item.url]"
          (click)="onNavigate(item)"
          >
          <img
            [src]="item.logo"
            [alt]="item.name"
            defaultImage="https://d1upatzsvnpphr.cloudfront.net/broker/notification_system/media/file/ic_placeholder_1.png"
            class="result-image"
            />
            <p class="result-context">{{ item.name }}</p>
            <div class="nav-icon">
              <img src="/images/icons/arrow-up-right-icon.svg" alt="" />
            </div>
          </a>
        }
      </div>
      @if (searchResult?.length > resultLimit) {
        <div class="button-container">
          <a
            class="stroked-button"
            mat-stroked-button
            color="primary"
            [routerLink]="['/search']"
            [queryParams]="{ keyword: query }"
            >
            All Result
          </a>
        </div>
      }
    </div>
  }

  @if (searchResult?.length === 0) {
    <p class="no-result-context">
      Unfortunately, no results found!
    </p>
  }
